export default [
  {
    path: "/workList",
    name: "用工列表",
    component: () => import("../views/workAndEmployment/workList/index.vue"),
  },
];
